import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core'
import { LocalStorageService } from '@services/local-storage/local-storage.service';


export const authGuard: CanActivateFn = (route, state) => {
	const authService = inject(LocalStorageService);
	const router = inject(Router);
	const urlToken = route.queryParamMap.get('token');
	// A WebView may retain local storage from a previous account. When the
	// caller supplies a token in the launch URL, it must take precedence over
	// that stale session so subsequent API requests use the intended owner.
	if (urlToken) {
		authService.setTokenAuth(urlToken);
		return true;
	}

	const token = authService.getTokenAuth();
	if (!token) {
		router.navigate(['/auth/login']);
		return false;
	}
	return true;
};
